import React from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import Link from 'components/Link';
import Text from 'components/Text';
import { colors } from 'theme';
import { LANGUAGES } from 'utils/constants';
import { createCookie } from 'utils/cookies';

import LanguageIcon from 'language-selection.svg';

const StyledLanguageIcon = styled(LanguageIcon)`
  width: 16px;
  height: 16px;
  opacity: 0.7;
`;
const DisabledLink = styled(Text)`
  color: ${colors.middleGrey};
  opacity: 0.5;
  cursor: auto;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LanguageLinks = ({
  className,
  url,
  showIcon = true,
}: {
  className?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  url: Record<string, any>;
  showIcon?: boolean;
}) => (
  <div className={className}>
    {showIcon && <StyledLanguageIcon />}
    {Object.keys(LANGUAGES).map((key) =>
      key !== USER_LOCALE ? (
        <Link
          key={key}
          href={url[key] || null}
          data-qa-id={`locale-link-${key}`}
          onClick={() => createCookie('_LOCALE_', key, 1825)}
          title={
            !url[key]
              ? sprintf(
                  getText(
                    'This page is currently not available in %(language)s'
                  ),
                  {
                    language: LANGUAGES[key],
                  }
                )
              : ''
          }
        >
          {LANGUAGES[key]}
        </Link>
      ) : (
        <DisabledLink data-qa-id={`disabled-locale-link-${key}`} key={key}>
          {LANGUAGES[key]}
        </DisabledLink>
      )
    )}
  </div>
);

export default LanguageLinks;
